
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { moneyRegexp } from "@root/lib/regexps";
const common = namespace("common");
const scan = namespace("scan");
const root = namespace("root");
const wt = namespace("wt");
const TAG_STATUS_DISABLE = 1; // 标签管理状态 禁用
const TAG_STATUS_ENABLE = 0; // 标签管理状态 启用
@Component({
  components: {}
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class TagSelect extends Vue {
  @root.State ddCodes;
  @wt.Action queryBrandList;
  @wt.Action queryActivityTagManage;
  @wt.Action getSystemTags;
  @wt.Action getK1TagManageBaseList;
  @scan.Action queryCustomerLevelList;

  @Prop({ default: () => {} }) value: object;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: "pcr" }) type: string; // tbr/pcr

  private tagType = "1";
  private form = {
    // storeCode: [],
    brandList: [],
    districtList: [],
    branchList: [],
    starList: [],
    storeTag: [],
    storeTags: []
    // type: ""
  };
  private brandDataOptions = [];
  private tagsOptions = [];
  private selectedList = [
    {
      selectedType: "",
      selectedValue: []
    }
  ];
  private selectedOptions = [
    // {
    //   id: 0,
    //   label: "品牌",
    //   value: "brandList",
    //   disabled: false
    // },
    // {
    //   id: 1,
    //   label: "区域",
    //   value: "districtList",
    //   disabled: false
    // },
    // {
    //   id: 2,
    //   label: "分部",
    //   value: "branchList",
    //   disabled: false
    // },
    // {
    //   id: 3,
    //   label: "星级",
    //   value: "starList",
    //   disabled: false
    // },
    // {
    //   id: 4,
    //   label: "门店类型",
    //   value: "storeTag",
    //   disabled: false
    // },
    {
      id: 5,
      label: "门店标签",
      value: "storeTags",
      disabled: false
    }
  ];

  get selectedOptionsList() {
    return this.selectedOptions.map(el => {
      const hasExists = this.selectedList.map(item => item.selectedType);
      const hasUsed = hasExists.includes(el && el.value);
      return { ...el, disabled: !!hasUsed };
    });
  }
  async init() {
    // await this.$dd
    //   .register([
    //     "SUBSECTION_CODE",
    //     "WT_STAR_TYPE",
    //     "DISTRICT_CODE",
    //     "STORE_TAGS",
    //     "STORE_TAG"
    //   ])
    //   .query();
    await this.getBrandOptions();
    // 标签管理
    await this.getTagOptions();
    // init Data
    const list = this.obj2arr(this.value) as any;
    if (list && list.length > 0) {
      this.selectedList = list;
    }
    // 区分标签，trb只有部分
    if (this.type === "tbr") {
      const tagIds = [3, 5];
      this.selectedOptions = this.selectedOptions.filter(({ id }) =>
        tagIds.includes(id)
      );
    }
    // if (!this.selectedList.length) return;
    // 设置响应式
    // this.selectedList.forEach(item => {
    //   this.$set(item, "selectedType", item["selectedType"] || "");
    //   this.$set(item, "selectedValue", item["selectedValue"] || []);
    // });
  }
  async getBrandOptions() {
    const { list } = await this.queryBrandList({
      condition: { locale: "zh-CN", orgCode: "default" },
      pageInput: { pageNum: 1, pageSize: 100000 }
    });
    this.brandDataOptions = list;
  }
  async getTagOptions() {
    // const { data: list } = await this.queryActivityTagManage({
    //   tagMarket: this.type.toUpperCase(),
    //   pageInput: { pageNum: 1, pageSize: 100000 }
    // });
    // this.tagsOptions = list.filter(
    //   ({ tagState }) => String(tagState) === String(TAG_STATUS_ENABLE)
    // );
    // getSystemTagsApi
    try {
      const list = await this.queryCustomerLevelList();
      console.log(list, "lsit");
      // this.storeLevelOptions = list || [];
      this.tagsOptions = list || [];
    } catch (error) {
      console.log(error);
    }
  }
  async created() {
    await this.init();
  }
  async onAddTag(val) {
    const item = {
      selectedType: "",
      selectedValue: []
    };
    this.selectedList.push(item as any);
    this.handleChangeType();
  }
  async onDeleteTag(item) {
    const index = this.selectedList.indexOf(item);
    if (index !== -1) {
      this.selectedList.splice(index, 1);
    }
    this.handleChangeType(item);
  }
  async handleChangeType(event?: any, item?: any) {
    // 清空已选标签，选择任一还是所有，不需要清，选择条件的key
    if (item) {
      item.selectedValue = [];
    }
    // 列表
    const selectedVals = this.arr2obj(this.selectedList);
    let emitDataObj = {};
    emitDataObj = { type: this.tagType, ...selectedVals };
    this.$emit("input", emitDataObj);
  }

  arr2obj(list) {
    let res = {};
    for (let item of list) {
      res[item["selectedType"] || "storeTags"] = item["selectedValue"];
    }
    return res;
  }

  obj2arr(obj) {
    if (!obj) {
      obj = { type: "1" };
    }
    const { type, ...otherObj } = obj;
    if (type) {
      this.tagType = type;
    }
    let arr = [];
    for (let key in otherObj) {
      const vals = otherObj[key];
      if (!vals || (vals && vals.length === 0)) return;
      arr.push({ selectedType: key, selectedValue: vals });
    }
    return arr;
  }
  fNumArab(num) {
    const cnStrArr = [
      "零",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十"
    ];
    let newObj = {};
    for (let idx in cnStrArr) {
      newObj[idx] = cnStrArr[idx];
    }
    const cnStr = newObj[num];
    return cnStr;
  }
}
